import React, { useState, useEffect } from 'react';

export default props=>{
    return (<div className="">
    <style jsx>{`

.fallback {
    position: fixed;
    z-index: 12;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
}

.padding-top {
    height: 100%;
    padding-top: 100px;
    width: 100%;
    text-align: left;

    position: fixed;
    top: 100px;
    bottom: 0;
    margin: 0 auto;
    left: 0;
    right: 0;
}

.grasp {
    height: 100%;
}

@media all and (max-width:606px) {
    .padding-top{
        position: initial;
        padding: 0;
        height: auto;
    }

    .fallback{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: overlay;
    }
}

`}</style>

    <div className="fallback" style={{ display: props.display }} 
    onMouseDown={props.hide} 
    >
        {props.innerContent}
    </div>

</div>);
};